module.exports = __webpack_public_path__ + "img/lar-ismael-voluntarios.ae7b3fce.jpeg";